import React from "react";

import { useAppContext } from "@app/helpers/hooks";

import type { TransferStop } from "../types";

import { TransferMessage } from "./transfer-message";
import { getDuration } from "../../../helpers/duration";
import { getMomentDurationInMinutes } from "../../../helpers/time";

export const TransferAlert: React.FC<{ transfer: TransferStop }> = ({
  transfer
}) => {
  const { translator } = useAppContext();

  const duration = transfer.transfer_duration
    ? getMomentDurationInMinutes(transfer.transfer_duration)
    : getDuration(transfer.departure_time, transfer.arrival_time);

  return transfer.arrival_name !== transfer.departure_name ? (
    <TransferMessage
      duration={duration}
      title={translator.t("!itinerary.transfer-stop.change-station")}
      type="change"
    />
  ) : (
    <TransferMessage
      duration={duration}
      title={translator.t("!departure.detail.transfer")}
    />
  );
};
